import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { Table, Input } from "reactstrap";
import axios from "axios";

function Balance() {
  const { user } = useContext(AuthContext);
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;

  const [info, setInfo] = useState([]);
  const [tipoCambio, setTipoCambio] = useState(21);

  useEffect(() => {
    axios
      .get(`${URL_DASHBOARDS}Balance`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => setInfo(response.data || []))
      .catch((err) => console.log(err));
  }, [URL_DASHBOARDS]);

  // ===== helpers numéricos =====
  const toNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const fmtMXN = useMemo(
    () =>
      new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        maximumFractionDigits: 2,
      }),
    []
  );

  const fmtUSD = useMemo(
    () =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }),
    []
  );

  const computed = useMemo(() => {
    const row = info?.[0] || {};

    const invMXN = toNum(row.ValorInventario);
    const cxcMXN = toNum(row.SaldoClientes);

    const cxpMXN = toNum(row.SaldoProveedoresMXN);
    const cxpUSD = toNum(row.SaldoProveedoresUSD);

    const tc = toNum(tipoCambio);

    const cxpTotalMXN = cxpMXN + (cxpUSD * tc);
    const balanceGeneralMXN = invMXN + cxcMXN - cxpTotalMXN;

    return {
      invMXN,
      cxcMXN,
      cxpMXN,
      cxpUSD,
      cxpTotalMXN,
      balanceGeneralMXN,
      tc,
    };
  }, [info, tipoCambio]);

  return (
    <>
      <Header />
      <br />
      <br />

      {user?.menu_reportes ? (
        <div className="card container col-sm-6">
          <h3 align="center">Balance</h3>

          {info.length > 0 ? (
            <Table>
              <tbody>
                <tr>
                  <th>Tipo de Cambio</th>
                  <td></td>
                  <td>
                    <Input
                      type="number"
                      placeholder="TipoCambio"
                      value={tipoCambio}
                      required
                      onChange={(e) => setTipoCambio(e.target.value)}
                    />
                  </td>
                </tr>

                <tr>
                  <th>Valor Inventario (MXN)</th>
                  <td></td>
                  <td>{fmtMXN.format(computed.invMXN)}</td>
                </tr>

                <tr>
                  <th>Cuentas Por Cobrar (MXN)</th>
                  <td></td>
                  <td>{fmtMXN.format(computed.cxcMXN)}</td>
                </tr>

                {/* ✅ PROVEEDORES SEPARADOS */}
                <tr>
                  <th>Cuentas Por Pagar (MXN)</th>
                  <td></td>
                  <td>{fmtMXN.format(computed.cxpMXN)}</td>
                </tr>

                <tr>
                  <th>Cuentas Por Pagar (USD)</th>
                  <td></td>
                  <td>{fmtUSD.format(computed.cxpUSD)}</td>
                </tr>

                <tr>
                  <th>CxP Total (MXN) = MXN + (USD * TC)</th>
                  <td></td>
                  <td>{fmtMXN.format(computed.cxpTotalMXN)}</td>
                </tr>

                <tr>
                  <th>Balance General (MXN)</th>
                  <td></td>
                  <td>{fmtMXN.format(computed.balanceGeneralMXN)}</td>
                </tr>
              </tbody>
            </Table>
          ) : null}
        </div>
      ) : null}
    </>
  );
}

export default Balance;
